const state = {
  list: null,
  request: {
    date: null,
    time: null,
    service_id: null,
    payment_type: null,
    description: null,
    contact: null,
    single: {
      date: "",
      time_flexible: true,
    },
    address_1: null,
    address_2: null,
    address: null
  },
  order: null,
  autocompleteValue: "",
  isComponent: "mainView",
  modalStatus: null,
  currentPage: 1,
  meta: {
    last_page: 2,
  },
  files: null,
  isShowEditAndComment: false
};

const mutations = {
  setState: (state, {
    key,
    value
  }) => {
    state[key] = value;
  },
  addToList: (state, data = []) => {
    state.list = [...state.list, ...data];
  },
  setList: (state, data = []) => {
    state.list = data;
  },
  clearOrders: () => {
    state.list = [];
    state.meta = {
      last_page: 2
    };
    state.currentPage = 1;
  },
  clearForm: (state) => {
    state.request.date = null;
    state.request.service_id = null;
    state.request.description = null;
    state.request.service_id = null;
    state.request.time = null;
    state.request.address_1 = null;
    state.request.address_2 = null;
  },
  setIsComponent: (state, v) => {
    const views = {
      new: "mainView",
      confirmed: "mainView",
      master_on_the_way: "mainView",
      master_arrived: "mainView",
      job_started: "mainView",
      job_finished: "mainView",
      payment: "paymentView",
      rating_review: "rateView",
      finished: "mainView",
      canceled: "mainView",
      error: "errorView",
      paymentWidget: "paymentWidget"
    };

    state.isComponent = views[v];
  },
  incPage: (state) => {
    if (state.meta == undefined) {
      return;
    }

    if (state.currentPage < state.meta.last_page) {
      state.currentPage = state.currentPage + 1;
    }
  },
};

const actions = {
  async fetch({
    state,
    commit
  }) {
    const response = await this.$api.orders.fetch(
      `?page=${state.currentPage}&limit=50`
    );
    return response.data;
  },
  async active() {
    const response = await this.$api.orders.fetch(`?active=true`);

    if (response.data.data == undefined) {
      return;
    }

    if (response.data.data.length == 0) {
      return;
    }

    return response.data.data[0];
  },
  async createRequest({
    state
  }, form) {
    const response = await this.$api.orders.createRequest(form);
    return response;
  },
  async uploadImage({
    state
  }, {
    form,
    id
  }) {
    if (!form) {
      return;
    }

    const fd = new FormData();

    fd.append("request_id", id);
    fd.append("media", form);

    const response = await this.$api.orders.uploadImage({
      form: fd,
      id,
    });
    return response;
  },
  async fetchFiles({
    commit
  }, id) {
    const response = await this.$api.orders.fetchFiles(id);

    commit('setState', {
      key: 'files',
      value: response.data.data || []
    })
  },

  async addFiles({}, form) {
    return await this.$api.orders.addFiles(form);
  },
  async fetchById({
    commit
  }, id) {
    const response = await this.$api.orders.fetchById(id);

    commit("setState", {
      key: "order",
      value: response.data.data,
    });

    return response;
  },
  async update({
    commit
  }, data) {
    const response = await this.$api.orders.update(data);
  },
  async updateDescription({}, {
    form,
    id
  }) {
    return await this.$api.orders.updateDescription(id, form);
  },
  async updateDate({}, {
    form,
    id
  }) {
    return await this.$api.orders.updateDate(id, form);
  },
  async updateContact({}, {
    form,
    id
  }) {
    return await this.$api.orders.updateContact(id, form);
  },
  async rate({
    dispatch
  }, data) {
    const {
      status
    } = await this.$api.orders.rate(data);

    if (status == 201) {
      await dispatch("update", {
        id: data.id,
        form: {
          status: "closed",
        },
      });
    }
  },
  async makePaid({}, id) {
    await this.$api.orders.makePaid(id);
  }
};

const getters = {
  list: (state) => state.list,
  request: (state) => state.request,
  order: (state) => state.order,
  autocompleteValue: (state) => state.autocompleteValue,

  isComponent: (state) => state.isComponent,
  modalStatus: (state) => state.modalStatus,
  isLastPage: (state) => state.meta.last_page === state.currentPage,
  files: state => state.files,
  isShowEditAndComment: state => state.isShowEditAndComment
};

export default {
  namespaced: true,

  state,
  mutations,
  actions,
  getters,
};